import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {BreadcrumbDTO} from '../model/breadcrumbDTO';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'breadcrumb';

  constructor(private http: HttpClient) {
  }

  getBreadcrumb(params) {
    return this.http.get<BreadcrumbDTO>(`${this.path}`, { params: params });
  }
}
